import axios from './axios';

// ----------------------
// Product APIs
// ----------------------

export function createProduct(product) {
    return axios.post('/api/products/product', product).then(res => res.data);
}

export function getProductById(id) {
    return axios.get(`/api/products/product/${id}`).then(res => res.data);
}

export function getAllProducts() {
    return axios.get('/api/products/product').then(res => res.data);
}

export function updateProduct(id, product) {
    return axios.put(`/api/products/product/${id}`, product).then(res => res.data);
}

export function deleteProductById(id) {
    return axios.delete(`/api/products/product/${id}`).then(res => res.status === 204);
}

export function queryProducts(params) {
    return axios.post('/api/products/query', params).then(res => res.data);
}

